import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangHuIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M.56 5.87A8.98 8.98 0 0 0 0 9c0 1.1.198 2.155.56 3.13l8.44.783 8.44-.783A8.98 8.98 0 0 0 18 9a8.98 8.98 0 0 0-.56-3.13L9 5.087.56 5.87Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 0A9.003 9.003 0 0 0 .56 5.87h16.88A9.003 9.003 0 0 0 9 0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18a9.003 9.003 0 0 0 8.44-5.87H.56A9.003 9.003 0 0 0 9 18Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangHuIconmin);
export { ForwardRef as ReactComponent };
